import { render, staticRenderFns } from "./ModalLessonGroupSetting.vue?vue&type=template&id=e27ad894&scoped=true&lang=pug&"
import script from "./ModalLessonGroupSetting.vue?vue&type=script&lang=ts&"
export * from "./ModalLessonGroupSetting.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLessonGroupSetting.vue?vue&type=style&index=0&id=e27ad894&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27ad894",
  null
  
)

export default component.exports